import { render, staticRenderFns } from "./Recruitment.vue?vue&type=template&id=1cc842cd&"
var script = {}
import style0 from "./Recruitment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports